import React from "react";
import { Link as RouterLink, NavLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Container,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Link,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const iconUrl = `${process.env.PUBLIC_URL}/assets/logo.svg`;

function NavItem({ to, children }) {
  return (
    <Link
      component={NavLink}
      to={to}
      underline="none"
      sx={{
        px: 1.25,
        py: 0.75,
        borderRadius: 999,
        color: "var(--color4)",
        fontWeight: 700,
        "&.active": {
          color: "var(--color5)",
          backgroundColor: "action.hover",
        },
        "&:hover": { backgroundColor: "action.hover", color: "var(--color5)", underline:"none" },
      }}
    >
      {children}
    </Link>
  );
}

export default function TopNav() {
  const [open, setOpen] = React.useState(false);

  const drawer = (
    <Box className="nav-menu" sx={{ width: 300, p: 2}}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle2" sx={{ color: "white" }}>
          Navigation
        </Typography>
        <Divider className='menu-divider' />
        <Button className="menu-dropdown-button" component={RouterLink} to="/" onClick={() => setOpen(false)} fullWidth>
            Home
        </Button>
        <Button className="menu-dropdown-button" component={RouterLink} to="/services" onClick={() => setOpen(false)} fullWidth>
            Services
        </Button>
        <Button className="menu-dropdown-button" component={RouterLink} to="/pricing" onClick={() => setOpen(false)} fullWidth>
            Pricing
        </Button>
        <Button className="menu-dropdown-button" component={RouterLink} to="/about" onClick={() => setOpen(false)} fullWidth>
            About
        </Button>
        <Button className="menu-dropdown-button" component={RouterLink} to="/contact" onClick={() => setOpen(false)} fullWidth>
          Contact
        </Button>
        <Divider className='menu-divider' />
      </Stack>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backdropFilter: "blur(10px)",
        backgroundColor: "var(--color1)",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 0.5 }}>
          <Stack direction="row" alignItems="center" spacing={1.25} sx={{ flexGrow: 1}}>
            <Box
              component={RouterLink}
              to="/"
              sx={{ display: "flex", alignItems: "center", gap: 1, textDecoration: "none", flex:2 }}
              aria-label="Brainwave Solutions home"
            >
              <img className="header-icon" src={iconUrl} alt="Light blue icon resembling a brain with circuit wires coming out from it." />
              <Typography variant="subtitle1" sx={{ fontWeight: 900, letterSpacing: -0.3}}>
                Brainwave Solutions
              </Typography>
            </Box>

            <Box sx={{ display: { xs: "none", md: "block", flex:1 }}}>
              <Stack direction="row" alignItems="right" spacing={0.5}>
                <NavItem to="/">Home</NavItem>
                <NavItem to="/services">Services</NavItem>
                <NavItem to="/pricing">Pricing</NavItem>
                <NavItem to="/about">About</NavItem>
                <NavItem to="/contact">Contact</NavItem>
              </Stack>
            </Box>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
        
            {/* <IconButton
              onClick={onToggleMode}
              aria-label="Toggle theme"
              sx={{ display: { xs: "none", md: "inline-flex" } }}
            >
              {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton> */}

            {/* <Button
              component={RouterLink}
              to="/contact"
              variant="contained"
              sx={{ display: { xs: "none", md: "inline-flex" } }}
            >
              Contact
            </Button> */}

            <IconButton
              onClick={() => setOpen(true)}
              aria-label="Open menu"
              sx={{ display: { xs: "inline-flex", md: "none" }, color:'white' }}
            >
              <MenuIcon />
            </IconButton>
          </Stack>

          <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
            {drawer}
          </Drawer>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
